import {
    MeetingServiceOrder,
    MeetingServiceOrderMeetingDetails,
} from "../../../../modules/merchant/accounting/accounting/accountingTypes"
import { OutlookSessionOrder } from "../../../../modules/order/pages/outlookCreateOrderTypes"

// ------------------------- utils -------------------------
type PartialDeep<T> = T extends Function
    ? T
    : T extends Array<infer U>
    ? Array<PartialDeep<U>>
    : T extends object
    ? { [K in keyof T]?: PartialDeep<T[K]> }
    : T

/** Normalization of organizers from meetingDetails → root */
function toRootOrganizers(
    orgs?: MeetingServiceOrderMeetingDetails["organizers"],
): MeetingServiceOrder["organizers"] | undefined {
    if (!orgs || orgs.length === 0) return undefined
    return orgs
}

// ------------------------- merge -------------------------
function normalizeMeetingDetailsPatch(
    md?: OutlookSessionOrder["meetingDetails"],
): PartialDeep<MeetingServiceOrderMeetingDetails> | undefined {
    if (!md) return undefined

    const { organizers, ...rest } = md

    const base = rest as PartialDeep<Omit<MeetingServiceOrderMeetingDetails, "location" | "locationAsObject">>

    if (typeof md.location === "string") {
        const normalized: PartialDeep<MeetingServiceOrderMeetingDetails> = {
            ...base,
            locationAsObject: { name: md.location },
        }
        return normalized
    }

    if (md.location) {
        const normalized: PartialDeep<MeetingServiceOrderMeetingDetails> = {
            ...base,
            location: md.location,
        }
        return normalized
    }

    return base
}

export const patchedOrderDetails = ({
    flowConfigOrder,
    orderDetails,
}: {
    flowConfigOrder?: OutlookSessionOrder
    orderDetails?: MeetingServiceOrder
}) => {
    if (!flowConfigOrder) return orderDetails

    if (!orderDetails) {
        const initialMeetingDetails = normalizeMeetingDetailsPatch(flowConfigOrder.meetingDetails)
        const order = {
            ...flowConfigOrder,
            meetingDetails: initialMeetingDetails,
            organizers: flowConfigOrder.meetingDetails?.organizers,
        } as MeetingServiceOrder
        return order
    }

    return orderDetails
}
